import { render, staticRenderFns } from "./SequenceNewPage.vue?vue&type=template&id=401a5140&"
import script from "./SequenceNewPage.vue?vue&type=script&lang=js&"
export * from "./SequenceNewPage.vue?vue&type=script&lang=js&"
import style0 from "./SequenceNewPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports